import { injectIntl } from 'react-intl';
import { isMobile } from 'react-device-detect';

const TabFilters = (props) => {
  const handleButtonClick = async (option) => {
    if (!option.selected) {
      const newOptions = props.options.map((opt) => {
        if (option.label === opt.label) {
          opt.selected = !opt.selected;
        } else {
          opt.selected = !opt.selected;
        }
        return opt;
      });
      await props.setTabFiltersOptions(newOptions);
    }
    await props.handleFilterValueChange({ target: option });
    await props.handleFiltersChange();
  };
  if (!props.showTabFilters) {
    return <></>;
  }
  return (
    <div className={`tabFilters ${isMobile ? 'mobile' : ''}`}>
      {props.options?.map((option) => {
        return (
          <button
            key={option.label}
            type='button'
            onClick={() => handleButtonClick(option)}
            className={`button tabFilter-button ${option.selected ? 'selected' : ''}`}
          >
            {props.intl.formatMessage({ id: option.label })} {option.count > -1 && option.count !== null && `[${option.count}]`}
          </button>
        );
      })}
    </div>
  );
};

export default injectIntl(TabFilters);
